module.exports = __webpack_public_path__ + "img/01446320000132.2bcd5e23.png";